export enum BadgeColor {
  blue = 'blue',
  purple = 'purple',
  gray = 'gray'
}
